import axios, { AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import { showToast } from '../components/toasts';

const retryDelay = (retryNumber = 0) => {
  retryMessage(retryNumber);
  const seconds = Math.pow(2, retryNumber) * 1000;
  const randomMs = 1000 * Math.random();
  return seconds + randomMs;
};

const retryMessage = (retryNumber: any) => {
  if(retryNumber === 2) {
    showToast('aafp_toast-warning', 'Still working on it...');
  }
};

export const apiRetry = (axiosInstance: AxiosInstance, retries = 1) => {
  axiosRetry(axiosInstance, { retries, retryDelay, retryCondition: axiosRetry.isRetryableError, });
}